var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 16,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.4961H15.8399V19.8701H0V12.4961Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_650)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92089 13.9961C3.65989 13.9961 1.49989 14.7281 1.49989 16.1731C1.49989 17.6311 3.65989 18.3701 7.92089 18.3701C12.1809 18.3701 14.3399 17.6381 14.3399 16.1931C14.3399 14.7351 12.1809 13.9961 7.92089 13.9961ZM7.92089 19.8701C5.96189 19.8701 -0.000106812 19.8701 -0.000106812 16.1731C-0.000106812 12.8771 4.52089 12.4961 7.92089 12.4961C9.87989 12.4961 15.8399 12.4961 15.8399 16.1931C15.8399 19.4891 11.3199 19.8701 7.92089 19.8701Z",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_278_650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60986 0H13.2299V10.6186H2.60986V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_278_650)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92089 1.42751C5.77989 1.42751 4.03789 3.16851 4.03789 5.30951C4.03089 7.44351 5.75989 9.18351 7.89189 9.19151L7.92089 9.90551V9.19151C10.0609 9.19151 11.8019 7.44951 11.8019 5.30951C11.8019 3.16851 10.0609 1.42751 7.92089 1.42751ZM7.92089 10.6185H7.8889C4.9669 10.6095 2.59989 8.22651 2.60989 5.30651C2.60989 2.38151 4.99189 -0.000488281 7.92089 -0.000488281C10.8489 -0.000488281 13.2299 2.38151 13.2299 5.30951C13.2299 8.23751 10.8489 10.6185 7.92089 10.6185Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.33ae3a00cc79fd972a8b06411e845f3c.svg";
export { ForwardRef as ReactComponent };